import { XIcon } from 'lucide-react';

import { Button } from '../../../../atoms';
import { useAdvancedFiltersInternalContext } from '../contexts/advanced-filters-internal.context';

import { AdvancedFiltersFieldSelect } from './AdvancedFiltersFieldSelect';
import { AdvancedFiltersOperatorSelect } from './AdvancedFiltersOperatorSelect';
import { AdvancedFiltersValueInput } from './AdvancedFiltersValueInput';

interface AdvancedFilterRowProps {
  rowId: string;
}

export const AdvancedFilterRow = ({ rowId }: AdvancedFilterRowProps) => {
  const { dispatch, state } = useAdvancedFiltersInternalContext();
  const disableDeleteButton = Object.keys(state.conditions).length === 1;
  const { field } = state.conditions[rowId];

  return (
    <div
      className="flex flex-row gap-2 h-10"
      data-testid={`${field}-condition`}
    >
      <div className="grid grid-cols-3 w-full border border-border rounded-sm shadow-sm overflow-hidden items-center">
        <AdvancedFiltersFieldSelect rowId={rowId} />
        <AdvancedFiltersOperatorSelect rowId={rowId} />
        <AdvancedFiltersValueInput rowId={rowId} />
      </div>
      <Button
        data-testid={`${field}-advanced-filter-remove-button`}
        id={`${field}-advanced-filter-remove-button`}
        size="icon-sm"
        aria-label="Remove filter"
        variant="outline"
        className="shadow-sm h-10 w-10"
        disabled={disableDeleteButton}
        onClick={() =>
          dispatch({ type: 'REMOVE_CONDITION', payload: { rowId } })
        }
      >
        <XIcon size={12} className="text-muted-foreground" />
      </Button>
    </div>
  );
};
